import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import SearchResult from '../views/SearchResult.vue';
import RankingMore from '../views/RankingMore.vue';
import InternalResource from '../views/InternalResource.vue';
import Login from '../views/Login.vue';
import Register from '../views/Register.vue';
import Profile from '../views/Profile.vue';
import Recharge from '../views/Recharge.vue';
import PanSearch from '../views/PanSearch.vue';
import PanDetail from '../views/PanDetail.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'InternalResource',
    component: InternalResource
  },
  {
    path: '/search',
    name: 'SearchResult',
    component: SearchResult
  },
  {
    path: '/ranking-more',
    name: 'RankingMore',
    component: RankingMore
  },
  {
    path: '/external',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: Recharge
  },
  {
    path: '/new-pan',
    name: 'PanSearch',
    component: PanSearch
  },
  {
    path: '/new-pan/detail/:id',
    name: 'PanDetail',
    component: PanDetail
  }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

export default router;
